import { isValidElement, type ReactElement, type ReactNode } from "react";

type InlineEditorProps = {
  value?: unknown;
};

export function extractBlogMdxSource(value: unknown): string {
  if (typeof value === "string") {
    return value;
  }

  if (value == null || value === false) {
    return "";
  }

  if (isValidElement(value)) {
    const props = value.props as InlineEditorProps;
    if (typeof props.value === "string") {
      return props.value;
    }
  }

  return "";
}

export function isPuckInlineEditorValue(
  value: unknown,
): value is ReactElement<InlineEditorProps> {
  return (
    isValidElement(value) &&
    typeof (value.props as InlineEditorProps)?.value === "string"
  );
}

export function renderBlogMdxFallback(value: unknown): ReactNode {
  if (value == null || value === false) {
    return null;
  }

  if (typeof value === "object") {
    return value as ReactNode;
  }

  return null;
}

/** Puck contentEditable fields are strings when stored but React nodes while editing. */
export function hasStudioEditableText(value: unknown): boolean {
  if (typeof value === "string") {
    return value.trim().length > 0;
  }

  return isValidElement(value);
}

export function renderStudioEditableText(value: unknown): ReactNode {
  if (typeof value === "string") {
    return value;
  }

  if (isValidElement(value)) {
    return value;
  }

  return null;
}
